// The candidates a reviewer chooses from: not the run's 'unverified' rows
// (listed separately as leads) and not ones the model scored 0. Candidates
// the model never scored (null) stay. Order is the run's; keys 1-9 follow it.
export function visibleCandidates(review) {
    return (review.candidates || []).filter(
        (c) => c.outcome !== 'unverified' && c.model_confidence !== 0)
}

// How many the model looked at and scored 0, for the "hidden" note.
export function zeroScoredCount(review) {
    return (review.candidates || []).filter(
        (c) => c.outcome !== 'unverified' && c.model_confidence === 0).length
}
